module.exports = __webpack_public_path__ + "img/register_wallpaper.d7516aad.jpg";